import debounce from 'lodash/debounce'
import PropTypes from 'prop-types'
import React, {Fragment, useCallback, useEffect, useState} from 'react'
import {
    getListSKUPrivate,
    getProductCatalogs,
    getProductCatalogsV2
} from '../../services/ProductLinesServices'
import MockupGeneratorListLoading from './MockupGeneratorListLoading'
import MockupGeneratorNavTab from './MockupGeneratorNavTab'
import MockupGeneratorTabContent from './MockupGeneratorTabContent'
import NavBar1 from './NavBar1'
import PFPagePagination from '../../shared/PFPagePagination'
import { removeEmptyObjectAttributes } from '../../helpers/cleanObject'
import { getSetting, hasFeatureTag } from '../../helpers/settings'

const MockupGeneratorListProduct = (props) => {
    const {store} = props
    const [loading, setLoading] = useState(false)
    const [query, setQuery] = useState({
        page: 1,
        title: '',
        category: '',
        onlyShopifyProducts: hasFeatureTag('shopifiy_public_app'),
    })
    const [pages, setPages] = useState(1)
    const [productCatalogs, setProductCatalogs] = useState([])
    const [selectedProduct, setSelectedProduct] = useState('')
    const [selectedCategoryObj, setSelectedCategoryObj] = useState({ _id: '', slug: 'all' })
    const [error, setError] = useState('')
    const [confirmModal, setConfirmModal] = useState(false)

    const _handleSearch = (value) => {
        verify(value)
    }

    const _fetchProductLine = useCallback(async () => {
        setLoading(true)
        setError('')
    
        try {
            const isStoreFfm = getSetting('disabled_storefront')
            
            const params = {
                ...query,
                limit: (isStoreFfm) ? 60 : 12,
                store_slug: store.storeId === "null" ? undefined : store.storeId,
                ...((isStoreFfm) ? {} : {
                    has_preview_v2: true,
                    available_for_campaign: true
                })
            }
            if (params.onlyShopifyProducts) {
                params.integration = 'shopify'
            }
            delete params.onlyShopifyProducts
    
            const cleanParams = removeEmptyObjectAttributes(params)
            const fetchFunction = Boolean(store.storeId) ? (isStoreFfm && !hasFeatureTag('exclude_combine_create_product_flow')) ? getProductCatalogsV2 : getProductCatalogs : getProductCatalogs
            const { data, success, message } = await fetchFunction(cleanParams)
    
            if (!success) {
                throw new Error(message)
            }
    
            const { products, pages } = data
            setProductCatalogs(products)
            setPages(pages)
        } catch (error) {
            setError(error.message)
        } finally {
            setLoading(false)
        }
    }, [query, store.storeId])

    const _fetchListSKUPrivate = useCallback(async () => {
        try {
            const { data, success, message } = await getListSKUPrivate()

            if (!success) {
                throw new Error(message)
            }
        } catch (error) {
            console.log(error.message)
        }
    }, [])

    const _handleSelectProduct = (productId) => setSelectedProduct(productId)

    const _handleSelectCategory = (categoryObj) => {
        setSelectedCategoryObj(categoryObj)
        setQuery((prev) => ({...prev, page: 1, category: categoryObj._id || ''}))
    }

    const _handleChangePage = (page) => setQuery((prev) => ({...prev, page}))

    const _handleFilterShopifyProducts = (onlyShopifyProducts) => {
        if (!onlyShopifyProducts) {
            setConfirmModal(true)
        } else {
            setQuery((prev) => ({...prev, page: 1, onlyShopifyProducts}))
        }
    }

    const verify = useCallback(
        debounce((value) => {
            setQuery((prev) => ({...prev, page: 1, title: value}))
        }, 1000),
        []
    )

    useEffect(() => {
        _fetchProductLine()
    }, [_fetchProductLine])

    useEffect(() => {
        _fetchListSKUPrivate()
    }, [])

    const classShowSideBar = true ? 'tab-content col-10' : 'tab-content-noSideBar col-12'

    return (
        <div className="MockupGeneratorListProduct">
            <NavBar1
                selectedProduct={selectedProduct}
                selectedProductObj={productCatalogs.find(p => p._id === selectedProduct) || null}
                selectedCategoryObj={selectedCategoryObj}
                txtSearch={query.title}
                onHandleSearch={_handleSearch}
            />

            <div className="d-flex CatalogMockupGeneratorPage FullHeight">
                <div className={classShowSideBar}>
                    {loading ? (
                        <MockupGeneratorListLoading columnQuantity={6} />
                    ) : error ? (
                        <p className="text-danger fs-14">
                            <i>{error}</i>
                        </p>
                    ) : Array.isArray(productCatalogs) && productCatalogs.length === 0 ? (
                        <p className="text-muted text-center">
                            <i>Stay tuned! New products are coming soon.</i>
                        </p>
                    ) : (
                        <Fragment>
                            <div className="ContentListProductMockupWrapper">
                                <MockupGeneratorTabContent
                                    selectedProduct={selectedProduct}
                                    onHandleSelectProduct={_handleSelectProduct}
                                    products={productCatalogs}
                                />
                            </div>
                            <PFPagePagination page={query.page} pages={pages} onChangePage={_handleChangePage} />
                        </Fragment>
                    )}
                </div>

                <MockupGeneratorNavTab
                    selectedCategory={query.category}
                    handleSelectCategory={_handleSelectCategory}
                    filterShopifyProducts={query.onlyShopifyProducts}
                    handleFilterShopifyProducts={_handleFilterShopifyProducts}
                    confirmModal={confirmModal}
                    setConfirmModal={setConfirmModal}
                    setQuery={setQuery}
                />
            </div>
        </div>
    )
}

MockupGeneratorListProduct.defaultProps = {
    showSidebar: true,
}

MockupGeneratorListProduct.propTypes = {
    showSidebar: PropTypes.bool.isRequired,
}

export default MockupGeneratorListProduct

